// extracted by mini-css-extract-plugin
export default {"btnSection":"styles_btnSection__2w6x3","ReturnBtn":"styles_ReturnBtn__fm1+2","HomeBtn":"styles_HomeBtn__RWmJx"};